// dependencies
import {
  registerReactCustomDetailComponent,
  registerReactFormInputComponent
} from '@vendure/admin-ui/react';
// components
import GenerateGUIDButton from './components/generate-code-button';
import ManagePartnerBalance from './components/manage-partner-balance';
import OpenPartnerBO from './components/open-partner-bo';
import RemoveSellerProperties from './components/remove-seller-properties';
import {InterlocutorsListComponent} from './components/interlocutor-tab/interlocutors-list-component';
import SoftwareHouseRelationSelect from './components/software-house-relation-select';
import IconUpload from './components/icon-upload';
import SellerCreateDefaults from './components/seller-create-defaults';
import DatetimeInput from './components/datetime-input';
import { IntegrationLeadsListComponent } from './components/integration-leads-tab/integration-leads-list-component';
import PriorityExpirationController from './components/priority-expiration-controller';

export default [
  registerReactCustomDetailComponent({
    locationId: 'seller-detail',
    component: ManagePartnerBalance
  }),
  registerReactCustomDetailComponent({
    locationId: 'seller-detail',
    component: OpenPartnerBO
  }),
  registerReactCustomDetailComponent({
    locationId: 'seller-detail',
    component: RemoveSellerProperties
  }),
  registerReactCustomDetailComponent({
    locationId: 'seller-detail',
    component: SellerCreateDefaults
  }),
  registerReactCustomDetailComponent({
    locationId: 'seller-detail',
    component: PriorityExpirationController
  }),
  registerReactFormInputComponent('generate-guid-button', GenerateGUIDButton),
  registerReactFormInputComponent('interlocutors-component', InterlocutorsListComponent),
  registerReactFormInputComponent('software-house-relation-select', SoftwareHouseRelationSelect),
  registerReactFormInputComponent('icon-upload', IconUpload),
  registerReactFormInputComponent('datetime-input', DatetimeInput),
  registerReactFormInputComponent('integration-leads-component', IntegrationLeadsListComponent),
  
];
